import { render } from "./Sugeridos.vue?vue&type=template&id=7539cb82&scoped=true"
import script from "./Sugeridos.vue?vue&type=script&lang=js"
export * from "./Sugeridos.vue?vue&type=script&lang=js"

import "./Sugeridos.vue?vue&type=style&index=0&id=7539cb82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7539cb82"

export default script